import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule }    from '@angular/material/divider';
import { MatRadioModule }      from '@angular/material/radio';
import { MatRippleModule }     from '@angular/material/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FeedbackFloaterComponent } from './feedback-floater/feedback-floater.component';
import { QuestionnaireComponent }   from './questionnaire/questionnaire.component';

import { AlertBoxModule } from '@shared/alert-box/alert-box.module';
import { PipesModule }    from '@shared/pipes/pipes.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from "@angular/router";


@NgModule({
  declarations: [
    QuestionnaireComponent,
    FeedbackFloaterComponent
  ],
  imports: [
    CommonModule,
    AlertBoxModule,
    FontAwesomeModule,
    MatDividerModule,
    MatRadioModule,
    MatRippleModule,
    PipesModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule
  ],
  exports: [
    QuestionnaireComponent,
    FeedbackFloaterComponent
  ]
})
export class QuestionnaireModule { }
